// extracted by mini-css-extract-plugin
export default {"container":"Io-z","brandName":"Jo-z","productName":"Ko-z","productNamePdpEnhancements":"Lo-z","breakLongProductName":"Mo-z"};